import { useEffect } from 'react';
import { BrowserRouter, MemoryRouter } from 'react-router-dom';
import App from './App';
import { OfficeApp } from './office/OfficeApp';
import { isOfficeEnvironment } from './hooks/useOffice';
import { initializeTelemetry } from './lib/telemetry';

export const AppRouter = () => {
    const is_office = isOfficeEnvironment();

    useEffect(() => {
        initializeTelemetry(is_office ? "memory" : "browser");
    }, [is_office]);

    if (is_office) {
        // use MemoryRouter for Office (no browser history API)
        return (
            <MemoryRouter>
                <OfficeApp />
            </MemoryRouter>
        );
    }

    // use BrowserRouter for web
    return (
        <BrowserRouter>
            <App />
        </BrowserRouter>
    );
};